import { render } from "./Domain.vue?vue&type=template&id=4a8a1642"
import script from "./Domain.vue?vue&type=script&lang=js"
export * from "./Domain.vue?vue&type=script&lang=js"

import exportComponent from "/home/ben/Projects/harborwall-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__